import { html } from 'lit';
const Now =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.114 3.678a.75.75 0 0 1 0 1.06L4.28 6.573a.75.75 0 0 1-1.06-1.06l1.833-1.834a.75.75 0 0 1 1.06 0m11.772 0a.75.75 0 0 1 1.061 0l1.833 1.833a.75.75 0 0 1-1.06 1.061l-1.834-1.833a.75.75 0 0 1 0-1.061M12 5.875a6.583 6.583 0 1 0 0 13.167 6.583 6.583 0 0 0 0-13.167m-8.083 6.583a8.083 8.083 0 1 1 16.166 0 8.083 8.083 0 0 1-16.166 0" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M15.197 10.359a.75.75 0 0 1 0 1.06l-3.555 3.556a.75.75 0 0 1-1.061 0l-1.778-1.778a.75.75 0 0 1 1.06-1.06l1.248 1.247 3.025-3.025a.75.75 0 0 1 1.061 0" clip-rule="evenodd"/>
  </svg>
`;
export default Now;
